var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.discountText)?_c('span',{staticClass:"discount-tag"},[_vm._v(_vm._s(_vm.discountText))]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }